import { px2rem, MEDIA_QUERY } from "@moim/common";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  @media ${MEDIA_QUERY.ONLY_MOBILE} {
    height: 100%;
  }
`;

export const HeadContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding-bottom: ${px2rem(8)};
`;
